module.exports = "/images/vendor/flag-icon-css/flags/4x3/sh.svg?6560d76bf10093362d933d31d620b17f";